var React = require('react');

function CloseModalWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_158","data-name":"Path 158","d":"M22.144-26.091a.74.74,0,0,0-.244-.536L16.6-31.92l5.206-5.2a.829.829,0,0,0,.2-.319.694.694,0,0,0,.12-.364.751.751,0,0,0-.245-.537l-.343-.341A.745.745,0,0,0,21-38.92a.741.741,0,0,0-.537.243l-5.315,5.305L9.829-38.677a.741.741,0,0,0-.537-.243.743.743,0,0,0-.537.243l-.343.341a.751.751,0,0,0-.245.537.694.694,0,0,0,.12.364.817.817,0,0,0,.2.319l5.206,5.2-5.3,5.292a.74.74,0,0,0-.244.536l0,.012,0,.013a.745.745,0,0,0,.245.536l.366.367a.741.741,0,0,0,.538.243.74.74,0,0,0,.536-.243l5.315-5.305,5.315,5.305a.74.74,0,0,0,.536.243.743.743,0,0,0,.538-.243l.366-.367a.745.745,0,0,0,.245-.536l0-.013Z","transform":"translate(-8.144 38.92)","fill":"#fafafc"}));
}

CloseModalWhite.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = CloseModalWhite;

CloseModalWhite.default = CloseModalWhite;
